import React, { useState, useEffect, useRef } from "react";
import { Button, Box, ClickAwayListener } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const buttonStyles = {
  fontFamily: "Urbanist, sans-serif",
  border: "1px solid rgb(255, 255, 255, .3)",
  color: "rgb(255, 255, 255, .3)",
};

export default function YearRangeFilter({ placeholder = "Years", onChange, apiUrl }) {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState([null, null]);
  const [years, setYears] = useState([]);

  const fetchYears = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data?.data?.years) {
        setYears(data.data.years.sort((a, b) => a - b)); // assicurati che siano ordinati
      }
    } catch (err) {
      console.error("Errore nel recuperare gli anni:", err);
    }
  };

  useEffect(() => {
    fetchYears();
  }, [apiUrl]);

  const handleYearClick = (year) => {
    if (!range[0] || (range[0] && range[1])) {
      setRange([year, null]);
    } else {
      const start = range[0];
      const newRange = year < start ? [year, start] : [start, year];
      setRange(newRange);
      onChange?.(newRange);
      setOpen(false);
    }
  };

  const handleReset = () => {
    setRange([null, null]);
    onChange?.([null, null]);
  };

  const isSelected = (year) => {
    const [start, end] = range;
    return (
      (start && end && year >= start && year <= end) || (start === year && !end)
    );
  };

  const label =
    range[0] && range[1]
      ? `${range[0]} - ${range[1]}`
      : range[0]
      ? `${range[0]}`
      : "";
    
  const buttonStyles = {
    fontFamily: 'Urbanist, sans-serif',
    border: open ? '1px solid rgb(var(--global-color-primary))' : '1px solid rgb(255, 255, 255)',
    color: open ? 'rgb(var(--global-color-primary))' : 'rgb(255, 255, 255)',
    textTransform: 'none',
    fontSize: '1rem',
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "relative", display: "flex", height:"100%" }}>
        
        
      <Button
        variant="outlined"
        onClick={() => setOpen(!open)}
        sx={{
          ...buttonStyles,
          position: 'relative',
          paddingRight: '30px',
        }}
      >
        {label !== "" ? label : placeholder}
      
        <ArrowDropDownIcon
          sx={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: open ? 'rgb(var(--global-color-primary))' : 'white',
          }}
        />
      </Button>


        {open && (
          <Box
            sx={{
              position: "absolute",
              top: "100%",
              mt: 1,
              p: 2,
              backgroundColor: "#111",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "8px",
              zIndex: 10,
              minWidth: "300px",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.5)",
              overflowX: "auto",
              whiteSpace: "normal",
              // 👇 gestione overflow: se serve, sposta a sinistra
              right: 0,
              left: "25%",
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {years.map((year) => (
                <button
                  key={year}
                  onClick={() => handleYearClick(year)}
                  style={{
                    padding: "6px 10px",
                    borderRadius: "6px",
                    backgroundColor: isSelected(year) ? "#C5FF55" : "#333",
                    color: isSelected(year) ? "#000" : "#fff",
                    border: "1px solid #C5FF55",
                    cursor: "pointer",
                    fontWeight: isSelected(year) ? "bold" : "normal",
                  }}
                >
                  {year}
                </button>
              ))}
            </div>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <button onClick={handleReset} style={{ padding: "6px 12px" }}>
                Reset
              </button>
              <div>
                Years:{" "}
                {range[0] && range[1]
                  ? `${range[0]} - ${range[1]}`
                  : range[0]
                  ? `${range[0]}`
                  : "None selected"}
              </div>
            </Box>
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
}
